/* eslint-disable
    no-unused-vars,
    prefer-const
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS201: Simplify complex destructure assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import {assert} from 'Asserts';
import * as sequtil from 'molbio/SeqUtil';
import * as shared from 'assembly/_shared';

const {basePlugin, getFlankingPrimers, getJunctions} = shared;

import * as AssemblyConstants from 'constants/AssemblyConstants';

const {ASSEMBLY_TYPE} = AssemblyConstants;

function replacePrimerRegion(sequence, primer, bases, primerStart, selStart, selEnd) {
  const primerBases = primer.bases();
  const startPos = sequtil.distance(primerStart, selStart, sequence.length(), sequence.circular());
  const endPos = sequtil.distance(primerStart, selEnd, sequence.length(), sequence.circular());
  return primerBases.slice(0, startPos) + bases + primerBases.slice(endPos);
}

function protectPrimerEnds(sequence, start, end, fwd, rev) {
  assert(start !== end, `protectPrimerEnds called on start = ${start} and end = ${end}`);
  const originalStart = start;
  const originalEnd = end;
  if (fwd != null) {
    end = sequtil.mod(end - 1, sequence.length());
  }
  if (rev != null) {
    start = sequtil.mod(start + 1, sequence.length());
  }
  // Do not want equal start and end after shifting to be interpreted as "entire sequence",
  // hence need to return null so caller knows to return.
  // The cleaner way to check this ends up being making sure "wrapping" is preserved.
  if (sequtil.isWrap(originalStart, originalEnd) !== sequtil.isWrap(start, end)) {
    return null;
  }
  return [start, end];
}

function findJunctionAtPosition(sequence, position) {
  // eslint-disable-next-line no-restricted-syntax
  return _.find(getJunctions(sequence), (junction) => {
    const [junction3, junction5] = Array.from(junction);
    return sequtil.baseInRange(position, junction3, sequtil.mod(junction5 + 1, sequence.length()));
  });
}

// eslint-disable-next-line no-restricted-syntax
const primerPlugin = _.extend({}, basePlugin, {
  _getTwoPrimerJunctionRanges(sequence, fwd, rev) {
    throw new Error(`Did not expect _getTwoPrimerJunctionRanges to be called on primerPlugin - \
make sure it's been implemented`);
  },

  // Finds ranges that can be edited prior to finalization.
  //   - For a junction with two primers, this corresponds to _getTwoPrimerJunctionRanges of the
  //     two primers' ranges.
  //   - For a junction with a primer on the 5' side and an enzyme on the 3' side, this
  //     corresponds to the upstream overhangEdge of the primer up until the 5' junction of the
  //     next parent.
  //   - For a junction with an enzyme on the 5' side, this corresponds to the reverse.
  _editableRanges(sequence) {
    const fragmentResults = sequence.fragmentResults();
    return fragmentResults
      .chain()
      .map((fragmentResult, i) => {
        const nextFragmentResult = fragmentResults.at((i + 1) % fragmentResults.length);
        const [fwd, rev] = Array.from(getFlankingPrimers(sequence, fragmentResult));
        const [nextFwd, nextRev] = Array.from(getFlankingPrimers(sequence, nextFragmentResult));
        const ranges =
          rev != null && nextFwd != null
            ? this._getTwoPrimerJunctionRanges(sequence, nextFwd, rev)
            : nextFwd != null
              ? [[fragmentResult.end(), nextFwd.end()]]
              : rev != null
                ? [[rev.start(), nextFragmentResult.start()]]
                : [];
        // eslint-disable-next-line no-restricted-syntax
        return _.map(ranges, (...args) => {
          const [start, end] = Array.from(args[0]);
          return [start, end, nextFwd, rev, fragmentResult.end(), nextFragmentResult.start()];
        });
      })
      .flatten(true)
      .value();
  },

  // Takes in deletionStart and deletionEnd instead of a selection object because, after
  // deletion, the end no longer matches up to the selection.
  _findDeleteRange(sequence, deletionStart, deletionEnd) {
    // eslint-disable-next-line no-restricted-syntax
    return _.find(this._editableRanges(sequence), (range) => {
      let [start, end, fwd, rev, junction3, junction5] = Array.from(range);
      const ends = protectPrimerEnds(sequence, start, end, fwd, rev);
      if (ends == null) {
        return false;
      }
      [start, end] = Array.from(ends);
      if (sequtil.isRangeWithin(deletionStart, deletionEnd, start, end)) {
        const legalStart = sequtil.mod(junction3 - 1, sequence.length());
        const legalEnd = sequtil.mod(junction5 + 1, sequence.length());
        return sequtil.isRangeOverlap(legalStart, legalEnd, deletionStart, deletionEnd);
      }
      return false;
    });
  },

  _findReplaceRange(sequence, selection) {
    // eslint-disable-next-line no-restricted-syntax
    return _.find(this._editableRanges(sequence), (range) => {
      let [start, end, fwd, rev, junction3, junction5] = Array.from(range);
      const ends = protectPrimerEnds(sequence, start, end, fwd, rev);
      if (ends == null) {
        return false;
      }
      [start, end] = Array.from(ends);
      return sequtil.isRangeWithin(selection.modelStart(), selection.modelEnd(), start, end);
    });
  },

  _canInsert(sequence, selection, errback) {
    throw new Error(`Did not expect _canInsert to be called on primerPlugin - \
make sure it's been implemented`);
  },

  _canInitiateReplace(sequence, selection, errback) {
    const range = this._findReplaceRange(sequence, selection);
    if (range != null) {
      return true;
    } else {
      if (sequence.assemblyType() === ASSEMBLY_TYPE.GOLDEN_GATE) {
        errback(
          "To replace bases that aren't under a primer's binding bases, finalize the sequence from the " +
            'results tab.'
        );
      } else {
        errback('To replace bases outside junctions, finalize the sequence from the results tab.');
      }
      return false;
    }
  },

  canEditSelection(sequence, selection, errback) {
    if (sequence.finalized()) {
      return true;
    }
    if (selection.isEmpty()) {
      return this._canInsert(sequence, selection, errback);
    }
    // Range is selected.
    return this._canInitiateReplace(sequence, selection, errback);
  },

  canReplace(sequence, selection, bases, errback) {
    if (sequence.finalized()) {
      return true;
    }
    const range = this._findReplaceRange(sequence, selection);
    if (range == null) {
      errback('To replace bases outside junctions, finalize the sequence from the results tab.');
      return false;
    }
    const [start, end, fwdPrimer, revPrimer] = Array.from(range);
    // Only check replacement length if there are primers.
    if (!(fwdPrimer != null || revPrimer != null)) {
      return true;
    }

    const dist = sequtil.distance(
      selection.modelStart(),
      selection.modelEnd(),
      sequence.length(),
      sequence.circular()
    );
    if (dist === bases.length) {
      return true;
    } else {
      errback('Replacement bases in regions must be the same length as the selection.');
      return false;
    }
  },
});

export {findJunctionAtPosition, primerPlugin, replacePrimerRegion};
